import styled from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { RETAILER_COLORS } from '@components/web/src/styles';

export const CommentContainer = styled(Flexbox)`
  background: ${RETAILER_COLORS.secondary['100']};
  border-radius: 6px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 5px;
  padding-left: 2px;
  padding-bottom: 8px;
`;
